<template>
  <main>
    <div class="row">
      <div class="col s12">
        <Tabs
          class="tabs-main"
          v-bind:tabNovaSimulacao="tabNovaSimulacao"
          v-bind:tabInicio="tabInicio"
          v-bind:tabMinhasSimulacoes="tabMinhasSimulacoes"
          @DefineTab="atualizarTab"
        />
        <div class="divider"></div>
      </div>
      <div id="welcome" class="col s12">
        <TabInicial />
      </div>
      <div id="new_simulation" class="col s12">
        <TabNovaSimulacao />
      </div>
      <div id="my_simulations" class="col s12">
        <TabMinhasSimulacoes />
      </div>
    </div>
  </main>
</template>
<script>
import TabInicial from "@/components/TabInicial.vue";
import TabNovaSimulacao from "@/components/TabNovaSimulacao.vue";
import TabMinhasSimulacoes from "@/components/TabMinhasSimulacoes.vue";
import Tabs from "@/components/Tabs.vue";
import $ from "jquery";
export default {
  name: "DashboardTabs",
  components: {
    TabInicial,
    TabNovaSimulacao,
    TabMinhasSimulacoes,
    Tabs
  },
  data() {
    let tab = this.$route.params.tab;
    return {
      tabNovaSimulacao: tab == "nova-simulacao" ? "active" : "",
      tabInicio: tab == "inicio" || tab == "" ? "active" : "",
      tabMinhasSimulacoes: tab == "minhas-simulacoes" ? "active" : ""
    };
  },
  methods: {
    goToInicio: function() {
      this.$router.push("/home/inicio");
    },
    goToNovaSimulacao: function() {
      this.$router.push("/home/nova-simulacao");
    },
    goToMinhasSimulacoes: function() {
      this.$router.push("/home/minhas-simulacoes");
    },
    atualizarTab: function() {}
  },
  mounted() {
    $(".tabs-main").css({
      display: "none"
    });
  }
};
</script>